import { useEffect, useRef } from 'react';
import { db } from '../firebase/config';
import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { auth } from '../firebase/config';

export const useExamLockdown = (
  examId: string,
  moduleId: string,
  enabled: boolean,
  onViolation?: () => void
) => {
  const onViolationRef = useRef(onViolation);
  onViolationRef.current = onViolation;

  useEffect(() => {
    if (!enabled) return;

    const logAttempt = async (type: string, detail: string) => {
      onViolationRef.current?.();
      const studentId = auth.currentUser?.uid;
      if (!studentId) return;
      try {
        const examLogsRef = collection(
          db,
          'modules',
          moduleId,
          'tests',
          examId,
          'submissions',
          studentId,
          'exam-logs'
        );
        await addDoc(examLogsRef, {
          type,
          timestamp: serverTimestamp(),
          detail
        });
      } catch (err) {
        console.error('Failed to log lockdown event:', err);
      }
    };

    const preventActions = (e: Event, type: string, detail: string) => {
      e.preventDefault();
      logAttempt(type, detail);
    };

    const handleCopy = (e: Event) =>
      preventActions(e, 'COPY_ATTEMPT', 'Copy attempted');
    const handlePaste = (e: Event) =>
      preventActions(e, 'PASTE_ATTEMPT', 'Paste attempted');

    const capture = true;
    document.addEventListener('copy', handleCopy, capture);
    document.addEventListener('paste', handlePaste, capture);

    return () => {
      document.removeEventListener('copy', handleCopy, capture);
      document.removeEventListener('paste', handlePaste, capture);
    };
  }, [examId, moduleId, enabled]);
};
